import { Card, DatePicker, Empty, Space } from "antd";
import ListTable from "common/ListTable";
import moment from "moment";
import { getData } from "apiServices/common";
import { useCallback, useEffect, useRef, useState } from "react";

const data = [
  {
    buyer: "MULTIMODA IMPORT, INC",
    sales_contract: "F&F/CGL/2024/02",
    pi_no: "PI12345",
    pi_value: "$10,000",
    import_value: "$9,800",
    pi_approver: "John Doe",
    pi_receive_date: "2025-01-01",
    btb_lc_open_date: "2025-01-05",
    btb_lc_number: "141425060004",
    invoice_number: "INV56789",
    import_payment_terms: "Deferred",
    issue_commission: "BDT 100",
    lc_stamp_charge: 500,
    amendment_charges: "BDT 50",
    sg_insurance_charges: "BDT 200",
    swift_charge: "BDT 150",
    btb_charge_usd: "USD 50",
    potential_saving_opportunity_charge: "USD 20",
    shipment_mode: "AIR",
    etd: "2025-01-10",
    import_doc_received_date: "2025-01-15",
    eta: "2025-01-20",
    berthing_date: "2025-01-22",
    unstuffing_date: "2025-01-23",
    import_quantity: "1000 Kgs",
    import_qty_rolls: "50",
    "cbm/kg": "10 CBM",
    unit: "Kgs",
    transport_qty: "1000",
    optimum_trucking: "5 Trucks",
    optimum_cost: "BDT 5,000",
    potential_opportunity_saving_trucking: "BDT 200",
    used_transport_qty: "1000",
    paid_transport_bill: "BDT 5,200",
    paid_cndf_bill: "BDT 2,000",
    cndf_other_air: "BDT 100",
    potential_opportunity_saving_cndf: "BDT 50",
    potential_opportunity_saving_cost: "BDT 300",
    description: "Textile Goods",
    good_release_date: "2025-01-25",
    inhouse_dt: "2025-01-26",
    acceptance_release_dt: "2025-01-27",
    due_dt: "2025-02-10",
    import_payment_release_date: "2025-02-15",
    acceptance_comission: "BDT 100",
  },
];

const columns = [
  {
    title: "Buyer",
    dataIndex: "buyer",
    key: "buyer",
    fixed: "left",
    children: [
      {
        title: "",
        fixed: "left",
        dataIndex: "buyer",
        key: "buyer",
      },
    ],
  },
  {
    title: "Sales Contract Number",
    dataIndex: "sales_contract",
    key: "sales_contract",
    children: [
      {
        title: "",
        dataIndex: "sales_contract",
        key: "sales_contract",
      },
    ],
  },
  {
    title: "PI No.",
    dataIndex: "pi_no",
    key: "pi_no",
    children: [
      {
        title: "",
        dataIndex: "pi_no",
        key: "pi_no",
      },
    ],
  },
  {
    title: "PI Value",
    dataIndex: "pi_value",
    key: "pi_value",
    children: [
      {
        title: "",
        dataIndex: "pi_value",
        key: "pi_value",
      },
    ],
  },
  {
    title: "Import Value",
    dataIndex: "import_value",
    key: "import_value",
    children: [
      {
        title: "",
        dataIndex: "import_value",
        key: "import_value",
      },
    ],
  },
  {
    title: "Supplier",
    dataIndex: "supplier",
    key: "supplier",
    children: [
      {
        title: "",
        dataIndex: "supplier",
        key: "supplier",
      },
    ],
  },
  {
    title: "PI Approver",
    dataIndex: "pi_approver",
    key: "pi_approver",
    children: [
      {
        title: "",
        dataIndex: "pi_approver",
        key: "pi_approver",
      },
    ],
  },
  {
    title: "PI Receive Date",
    dataIndex: "pi_receive_date",
    key: "pi_receive_date",
    children: [
      {
        title: "",
        dataIndex: "pi_receive_date",
        key: "pi_receive_date",
      },
    ],
  },
  {
    title: "BTB LC Open Date",
    dataIndex: "btb_lc_open_date",
    key: "btb_lc_open_date",
    children: [
      {
        title: "",
        dataIndex: "btb_lc_open_date",
        key: "btb_lc_open_date",
      },
    ],
  },
  {
    title: "BTB LC Number",
    dataIndex: "btb_lc_number",
    key: "btb_lc_number",
    children: [
      {
        title: "",
        dataIndex: "btb_lc_number",
        key: "btb_lc_number",
      },
    ],
  },
  {
    title: "Import Payment Terms",
    dataIndex: "import_payment_terms",
    key: "import_payment_terms",
    children: [
      {
        title: "",
        dataIndex: "import_payment_terms",
        key: "import_payment_terms",
      },
    ],
  },
  {
    title: "LC Stamp Charge (@500/Par application)[BDT]",
    dataIndex: "lc_stamp_charge",
    key: "lc_stamp_charge",
    children: [
      {
        title: "Auto transaction/LC wise",
        dataIndex: "lc_stamp_charge",
        key: "lc_stamp_charge",
      },
    ],
  },
  {
    title: "Amendment Charges [BDT]",
    dataIndex: "amendment_charges",
    key: "amendment_charges",
    children: [
      {
        title: "Auto transaction/LC wise",
        dataIndex: "amendment_charges",
        key: "amendment_charges",
      },
    ],
  },
  {
    title: "SG Issuance Charge [BDT]",
    dataIndex: "sg_insurance_charges",
    key: "sg_insurance_charges",
    children: [
      {
        title: "Auto transaction/LC wise",
        dataIndex: "sg_insurance_charges",
        key: "sg_insurance_charges",
      },
    ],
  },
  {
    title: "Swift Charge [BDT]",
    dataIndex: "swift_charge",
    key: "swift_charge",
    children: [
      {
        title: "Auto transaction/LC wise",
        dataIndex: "swift_charge",
        key: "swift_charge",
      },
    ],
  },
  {
    title: "BTB Charge [USD]",
    dataIndex: "btb_charge_usd",
    key: "btb_charge_usd",
    children: [
      {
        title: "Auto transaction/LC wise",
        dataIndex: "btb_charge_usd",
        key: "btb_charge_usd",
      },
    ],
  },
  {
    title: "Potential Saving Opportunity [USD]",
    dataIndex: "potential_saving_opportunity_charge",
    key: "potential_saving_opportunity_charge",
    children: [
      {
        title: "USA",
        dataIndex: "potential_saving_opportunity_charge",
        key: "potential_saving_opportunity_charge",
      },
    ],
  },
  {
    title: "Shipment Mode",
    dataIndex: "shipment_mode",
    key: "shipment_mode",
    children: [
      {
        title: "",
        dataIndex: "shipment_mode",
        key: "shipment_mode",
      },
    ],
  },
  {
    title: "ETD",
    dataIndex: "etd",
    key: "etd",
    children: [
      {
        title: "",
        dataIndex: "etd",
        key: "etd",
      },
    ],
  },
  {
    title: "Import Document Receive Date",
    dataIndex: "import_doc_received_date",
    key: "import_doc_received_date",
    children: [
      {
        title: "",
        dataIndex: "import_doc_received_date",
        key: "import_doc_received_date",
      },
    ],
  },
  {
    title: "ETA",
    dataIndex: "eta",
    key: "eta",
    children: [
      {
        title: "",
        dataIndex: "eta",
        key: "eta",
      },
    ],
  },
  {
    title: "Berthing Date",
    dataIndex: "berthing_date",
    key: "berthing_date",
    children: [
      {
        title: "",
        dataIndex: "berthing_date",
        key: "berthing_date",
      },
    ],
  },
  {
    title: "Unstuffing Date",
    dataIndex: "unstuffing_date",
    key: "unstuffing_date",
    children: [
      {
        title: "",
        dataIndex: "unstuffing_date",
        key: "unstuffing_date",
      },
    ],
  },
  {
    title: "Import Quantity",
    dataIndex: "import_quantity",
    key: "import_quantity",
    children: [
      {
        title: "",
        dataIndex: "import_quantity",
        key: "import_quantity",
      },
    ],
  },
  {
    title: "Import Qty/Rolls",
    dataIndex: "import_qty_rolls",
    key: "import_qty_rolls",
    children: [
      {
        title: "",
        dataIndex: "import_qty_rolls",
        key: "import_qty_rolls",
      },
    ],
  },
  {
    title: "CBM/Kgs",
    dataIndex: "cbm/kg",
    key: "cbm/kg",
    children: [
      {
        title: "",
        dataIndex: "cbm/kg",
        key: "cbm/kg",
      },
    ],
  },
  {
    title: "Unit",
    dataIndex: "unit",
    key: "unit",
    children: [
      {
        title: "",
        dataIndex: "unit",
        key: "unit",
      },
    ],
  },
  {
    title: "Transport Quantity",
    dataIndex: "transport_qty",
    key: "transport_qty",
    children: [
      {
        title: "",
        dataIndex: "transport_qty",
        key: "transport_qty",
      },
    ],
  },
  {
    title: "Optimum Trucking",
    dataIndex: "optimum_trucking",
    key: "optimum_trucking",
    children: [
      {
        title: "",
        dataIndex: "optimum_trucking",
        key: "optimum_trucking",
      },
    ],
  },
  {
    title: "Optimum Cost",
    dataIndex: "optimum_cost",
    key: "optimum_cost",
    children: [
      {
        title: "",
        dataIndex: "optimum_cost",
        key: "optimum_cost",
      },
    ],
  },
  {
    title: "Potential Opportunity for Savings in Trucking",
    dataIndex: "potential_opportunity_saving_trucking",
    key: "potential_opportunity_saving_trucking",
    children: [
      {
        title: "USA",
        dataIndex: "potential_opportunity_saving_trucking",
        key: "potential_opportunity_saving_trucking",
      },
    ],
  },
  {
    title: "Used Transport Qty",
    dataIndex: "used_transport_qty",
    key: "used_transport_qty",
    children: [
      {
        title: "",
        dataIndex: "used_transport_qty",
        key: "used_transport_qty",
      },
    ],
  },
  {
    title: "Paid Transport Bill",
    dataIndex: "paid_transport_bill",
    key: "paid_transport_bill",
    children: [
      {
        title: "Cash transaction/Invoice wise",
        dataIndex: "paid_transport_bill",
        key: "paid_transport_bill",
      },
    ],
  },
  {
    title: "Paid C&F Bill",
    dataIndex: "paid_cndf_bill",
    key: "paid_cndf_bill",
    children: [
      {
        title: "Cash transaction/Invoice wise",
        dataIndex: "paid_cndf_bill",
        key: "paid_cndf_bill",
      },
    ],
  },
  {
    title: "C&F Others (Air)",
    dataIndex: "cndf_other_air",
    key: "cndf_other_air",
    children: [
      {
        title: "Cash transaction/Invoice wise",
        dataIndex: "cndf_other_air",
        key: "cndf_other_air",
      },
    ],
  },
  {
    title: "Potential Opportunity for Savings in C&F",
    dataIndex: "potential_opportunity_saving_cndf",
    key: "potential_opportunity_saving_cndf",
    children: [
      {
        title: "Cash transaction/Invoice wise",
        dataIndex: "potential_opportunity_saving_cndf",
        key: "potential_opportunity_saving_cndf",
      },
    ],
  },
  {
    title: "Potential Opportunity in Storage Cost",
    dataIndex: "potential_opportunity_saving_cost",
    key: "potential_opportunity_saving_cost",
    children: [
      {
        title: "",
        dataIndex: "potential_opportunity_saving_cost",
        key: "potential_opportunity_saving_cost",
      },
    ],
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    children: [
      {
        title: "",
        dataIndex: "description",
        key: "description",
      },
    ],
  },
  {
    title: "Goods Release Date",
    dataIndex: "good_release_date",
    key: "good_release_date",
    children: [
      {
        title: "",
        dataIndex: "good_release_date",
        key: "good_release_date",
      },
    ],
  },
  {
    title: "Inhouse Date",
    dataIndex: "inhouse_dt",
    key: "inhouse_dt",
    children: [
      {
        title: "",
        dataIndex: "inhouse_dt",
        key: "inhouse_dt",
      },
    ],
  },
  {
    title: "Acceptance Release Date",
    dataIndex: "acceptance_release_dt",
    key: "acceptance_release_dt",
    children: [
      {
        title: "",
        dataIndex: "acceptance_release_dt",
        key: "acceptance_release_dt",
      },
    ],
  },
  {
    title: "Due Date",
    dataIndex: "due_dt",
    key: "due_dt",
    children: [
      {
        title: "",
        dataIndex: "due_dt",
        key: "due_dt",
      },
    ],
  },
  {
    title: "Import Payment Release Date",
    dataIndex: "import_payment_release_date",
    key: "import_payment_release_date",
    children: [
      {
        title: "",
        dataIndex: "import_payment_release_date",
        key: "import_payment_release_date",
      },
    ],
  },
  {
    title: "Acceptance Commission (@.1%)",
    dataIndex: "acceptance_comission",
    key: "acceptance_comission",
    children: [
      {
        title: "Auto transaction/LC wise",
        dataIndex: "acceptance_comission",
        key: "acceptance_comission",
      },
    ],
  },
];

const PAGE_SIZE = 50;

const ImportDetailsReport = () => {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);
  const [withoutDate, setWithoutDate] = useState(0);
  // ux2(final-2): the backend now paginates only when per_page is sent (whole-branch review C-1);
  // this page always sends per_page so a widened range shows a real pager instead of a silent 50.
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  // ux2(C1): import_date has no default filter today; open on the last 30 days so the page
  // isn't blank, while the endpoint stays backward compatible when from_date/to_date are absent.
  const getDefaultDateRange = () => [moment().subtract(29, "days"), moment()];
  const [dateRange, setDateRange] = useState(getDefaultDateRange);

  // Guard against setState after unmount and against a slower, stale request clobbering a
  // faster, later one (round-1 pattern).
  const mountedRef = useRef(true);
  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);
  const reqIdRef = useRef(0);

  const fetchImportDetails = useCallback(() => {
    const myReq = ++reqIdRef.current;
    setLoading(true);
    setFetchError(null);
    const [from, to] = dateRange || [];
    // /api/import-expense/import-expense-report
    getData("/api/import-expense/import-expense-report", false, {
      ...(from && to && { from_date: from.format("YYYY-MM-DD"), to_date: to.format("YYYY-MM-DD") }),
      per_page: PAGE_SIZE,
      page,
    })
      .then((data) => {
        if (!mountedRef.current || myReq !== reqIdRef.current) return;
        if (!data || data?.status !== 200) {
          setFetchError("Could not load this list.");
          return;
        }
        setDataSource(data?.data?.data?.data);
        setWithoutDate(data?.data?.data?.meta?.without_date || 0);
        setTotal(data?.data?.data?.total || 0);
      })
      .catch((error) => {
        if (!mountedRef.current || myReq !== reqIdRef.current) return;
        setFetchError(error?.message || "Could not load this list.");
      })
      .finally(() => {
        if (!mountedRef.current || myReq !== reqIdRef.current) return;
        setLoading(false);
      });
  }, [dateRange, page]);

  useEffect(() => {
    fetchImportDetails();
  }, [fetchImportDetails]);

  const handleDateRangeChange = (dates) => {
    setPage(1);
    setDateRange(dates && dates[0] && dates[1] ? dates : getDefaultDateRange());
  };

  return (
    <Card title="Import Details Report" style={{ width: "100%" }}>
      <Space style={{ marginBottom: 8 }}>
        <span>Import Date:</span>
        <DatePicker.RangePicker size="small" value={dateRange} onChange={handleDateRangeChange} allowClear={false} />
        {withoutDate > 0 && <span>({withoutDate} rows have no import date and are excluded from any range)</span>}
      </Space>
      <ListTable
        dataSource={dataSource}
        columns={columns}
        scroll={{
          x: "max-content",
        }}
        bordered
        pagination={{
          current: page,
          pageSize: PAGE_SIZE,
          total,
          onChange: (nextPage) => setPage(nextPage),
        }}
        loading={loading}
        error={fetchError}
        onRetry={() => fetchImportDetails()}
        size="small"
        locale={{
          emptyText: (
            <Empty
              description={`No records between ${dateRange?.[0]?.format("DD-MMM-YYYY")} and ${dateRange?.[1]?.format(
                "DD-MMM-YYYY",
              )}. Widen the range above.`}
            />
          ),
        }}
        style={{
          margin: "20px 0",
        }}
      />
    </Card>
  );
};

export default ImportDetailsReport;
